import { useAppSelector } from "@hooks/redux";
import { PageSider } from "@layouts/PageSider";
import Loading from "@src/ui/Loading";

interface PageReadyProps {
  children: React.ReactNode;
  noSider?: boolean;
}

export default ({ children, noSider = false }: PageReadyProps) => {
  const { i18Ready, pageLoading } = useAppSelector((state) => state.globalReducer);
  const { ready: configReady } = useAppSelector((state) => state.configReducer);

  const pageReady = !pageLoading && i18Ready && configReady;

  if (pageReady && noSider) {
    return <>{children}</>;
  } else if (pageReady) {
    return (
      <div className="flex min-h-[600px] h-screen">
        <PageSider />
        <div className="flex-1 min-h-[600px] overflow-y-auto">{children}</div>
      </div>
    );
  } else {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <Loading></Loading>
      </div>
    );
  }
};
